<template>
    <component :is="linksComponent" v-bind="$attrs" />
</template>

<script setup>
import { resolveCorporateView } from '@/composables/useCorporateUserRole.js';
import CorporateAdminTopbarLinks from '@/layouts/navigation/CorporateAdminTopbarLinks.vue';
import CorporateStudentTopbarLinks from '@/layouts/navigation/CorporateStudentTopbarLinks.vue';

// Role-axis resolver for the corporate client variant topbar links. The client axis
// is resolved by `TopbarLinks.vue`; this file then picks between corporate
// admin and corporate student variants based on user roles. See
// docs/corporate-client-pattern.md for the two-axis pattern.
defineOptions({
    name: 'CorporateTopbarLinks',
    inheritAttrs: false,
});

const linksComponent = resolveCorporateView({
    admin: CorporateAdminTopbarLinks,
    student: CorporateStudentTopbarLinks,
});
</script>
